import { Box, Flex, Text, VStack } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { NumberedStep } from '../numbered-step';
import { StoreBadges } from 'components/app-download';

export const PairDevicesStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle stepNumber={5} title="Pair Your Devices" />

        {/* Intro Text */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <Text fontSize="sm" color="gray.800" lineHeight="1.6">
            To remotely monitor battery life and adjust your camera's tilt and
            zoom from your phone/tablet during a game, you'll need to download
            FrogBox Connect and pair your phone/tablet with the camera.
          </Text>
        </Box>

        {/* Step 1: Download App */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <NumberedStep number={1}>
              <Text as="span">
                Download{' '}
                <Text as="span" fontWeight="bold">
                  FrogBox Connect
                </Text>{' '}
                (it's free!)
              </Text>
            </NumberedStep>

            <Box pl={9}>
              <StoreBadges size="sm" layout="horizontal" />
            </Box>
          </VStack>
        </Box>

        {/* Step 2: Turn on Bluetooth */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <NumberedStep number={2}>
              <Text as="span" fontWeight="bold">
                Turn on Bluetooth
              </Text>
            </NumberedStep>

            <VStack align="flex-start" gap={2} pl={9}>
              <Text fontSize="sm" color="gray.700">
                • <Text as="span" fontWeight="semibold">Phone / Tablet:</Text>{' '}
                Settings → Bluetooth → On
              </Text>
              <Text fontSize="sm" color="gray.700">
                • <Text as="span" fontWeight="semibold">Camera:</Text> Check to
                make sure the camera is on. If not, press the back button (solid
                white light = camera on). Next, hold the black button for 3
                seconds (flashing blue = pairing mode)
              </Text>
            </VStack>
          </VStack>
        </Box>

        {/* Step 3: Pair Devices */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <NumberedStep number={3}>
              <Text as="span" fontWeight="bold">
                Pair Devices
              </Text>
            </NumberedStep>

            <VStack align="flex-start" gap={2} pl={9}>
              <Text fontSize="sm" color="gray.700">
                • <Text as="span" fontWeight="semibold">Phone / Tablet:</Text>{' '}
                Bluetooth → Pair with FrogBoxV2-XXXX
              </Text>
              <Text fontSize="sm" color="gray.700">
                • <Text as="span" fontWeight="semibold">FrogBox Connect:</Text>{' '}
                Open app → Scan → Connect FrogBoxV2-XXXX
              </Text>
            </VStack>
          </VStack>
        </Box>

        {/* Step 4: Successful Pairing */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <NumberedStep number={4}>
              <Text as="span" fontWeight="bold">
                Successful Pairing
              </Text>
            </NumberedStep>

            <VStack align="flex-start" gap={2} pl={9}>
              <Text fontSize="sm" color="gray.700">
                • Brief solid blue light on camera = connected
              </Text>
              <Text fontSize="sm" color="gray.700">
                • Light returns to solid white
              </Text>
            </VStack>
          </VStack>
        </Box>

        {/* Diagram */}
        <Box w="full" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/pair-devices.webp`}
            alt="Device pairing instructions"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </VStack>
    </Flex>
  );
};
